import styled from "styled-components";

type Params = {
    $catId: string;
}

export const CatSkeenBox = styled.div<Params>`
    background: url("${(p) => '/walk/skeen/' + p.$catId}");
    width: 128px;
    background-size: 384px 512px;
    background-position-x: -128px;
    height: 128px;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    top: 125px;
    position: absolute;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
`;
